import React, { forwardRef, ReactNode, Ref } from 'react';
import { NavPanel, NavPanelRefType } from '../navpanel';
import { NavBarCancelButton } from '../../components/controls/navbar';
import { ModalContainer } from '../modal/ModalContainer';

/**
 * {@docCategory ModalNavPanel}
 */
export interface ModalNavPanelProps {
   title: string;
   visible?: boolean;
   cancelText?: string;
   onClose?: () => void;
   analyticsName?: string;
   children?: ReactNode;
}

export const ModalNavPanel = forwardRef<NavPanelRefType, ModalNavPanelProps>(
   (props: ModalNavPanelProps, ref: Ref<NavPanelRefType>) => {
      return (
         <ModalContainer
            visible={props.visible}
            size={'fullscreen'}
            shouldCloseOnMaskClick={false}
            shouldCloseOnEsc={false}
            analyticsName={props.analyticsName}
         >
            <NavPanel
               title={props.title}
               rootNavBarLeftItem={closeButton(props)}
               ref={ref}
            >
               {props.children}
            </NavPanel>
         </ModalContainer>
      );
   });

const closeButton = (props: ModalNavPanelProps) => {
   return (
      <NavBarCancelButton
         text={props.cancelText}
         onClick={() => {
            if (props.onClose) {
               props.onClose();
            }
         }}
      />
   );
};
